import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebPage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M19.3489 17.5853H24.0553M19.3489 21.9932H24.0553M9.5505 8.73302H9.47655M12.8645 8.73302H12.7906M16.1785 8.73302H16.1045M29.0899 12.6556H5.09114M11.4683 4.00061H22.714C26.6447 4.00061 29.0899 6.77538 29.0899 10.7021V21.2978C29.0899 25.2246 26.6447 27.9993 22.7127 27.9993H11.4683C7.53771 27.9993 5.09114 25.2246 5.09114 21.2978V10.7021C5.09114 6.77538 7.54939 4.00061 11.4683 4.00061ZM13.6496 22.317H11.6622C10.8151 22.317 10.1276 21.6308 10.1276 20.7824V18.7964C10.1276 17.948 10.8151 17.2617 11.6622 17.2617H13.6496C14.4967 17.2617 15.1843 17.948 15.1843 18.7964V20.7824C15.1843 21.6308 14.4967 22.317 13.6496 22.317Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWebPage;
